"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePubSubSubscribe = exports.usePubSubContext = exports.PubSubProvider = exports.usePubSub = void 0;
const react_1 = require("react");
const createPropsContextProvider_1 = require("../createPropsContextProvider");
const pubSub_1 = require("../pubSub");
const createUseDefinedContext_1 = require("./createUseDefinedContext");
/**
 * A hook that returns instance of a PubSub mechanism to enable two-way
 * communication between parent and nested components.
 * @returns instance of new PubSub
 */
const usePubSub = () => (0, react_1.useMemo)(pubSub_1.createPubSub, []);
exports.usePubSub = usePubSub;
const context = (0, react_1.createContext)(undefined);
exports.PubSubProvider = (0, createPropsContextProvider_1.createPropsContextProvider)(context);
exports.usePubSubContext = (0, createUseDefinedContext_1.createUseDefinedContext)(context, 'PubSub context not found. You should provide PubSub to the context');
/**
 * A hook that activates the subscription for the time the component is mounted
 * @param topic a PubSub topic to subscribe to
 * @param handler a handler of the subscription
 */
const usePubSubSubscribe = (topic, handler) => {
    const { pubSub } = (0, exports.usePubSubContext)();
    // @ts-ignore
    (0, react_1.useEffect)(() => {
        if (handler) {
            const unsubscribe = pubSub.subscribe(topic, handler);
            return () => {
                unsubscribe();
            };
        }
    }, [pubSub, handler, topic]);
};
exports.usePubSubSubscribe = usePubSubSubscribe;
//# sourceMappingURL=usePubSub.js.map